import styled from 'styled-components';
import { FilterMultiselectOption } from 'src/components/filters/FilterMultiselect';
import { FilterMultiselectDescription } from 'src/components/filters/types';

const FilterTagsOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0 6px;
`;

export const FilterTagsOptions = ({
  filter,
}: {
  filter: FilterMultiselectDescription;
}) => {
  return (
    <FilterTagsOptionsContainer>
      {filter.options.map((option) => (
        <FilterMultiselectOption
          key={option.value}
          name={filter.queryField}
          option={option}
        />
      ))}
    </FilterTagsOptionsContainer>
  );
};
